<mat-form [formGroup]="this.formGroup">
  @for (field of this.formDefinition; track field.name) {
    <label>{{ field.title }}</label>
    @if (!['multifile'].includes(field.type)) {
      <mat-form-field appearance="fill" hideRequiredMarker>
        <span matTextPrefix>{{ field.prefix }}&nbsp;</span>
        <!-- Normal input fields -->
        @if (field.editable && !['slide', 'select'].includes(field.type)) {
          <!-- For non-phone fields -->
          @if (field.format == undefined) {
            <input
              matInput
              [formControlName]="field.name"
              [type]="field.type"
              [placeholder]="field.placeholder ?? ''"
              [readonly]="!field.editable"
              [hidden]="!field.editable"
              [value]="field.control.value"
              (keydown.enter)="doLogin(field)"
              class="form-input"
              [matTooltip]="field.tooltip ? field.tooltip : ''"
              [matTooltipClass]="field.tooltip ? 'custom-tooltip' : ''"
              #tooltip="matTooltip"
              (focus)="field.tooltip && tooltip.show()"
              (input)="field.tooltip && tooltip.show()"
              (blur)="field.tooltip && tooltip.hide()"
              />
          }
          <!-- For phone fields -->
          @if (field.format == 'phone') {
            <input
              matInput
              [formControlName]="field.name"
              [type]="field.type"
              [placeholder]="field.placeholder ?? ''"
              [readonly]="!field.editable"
              [hidden]="!field.editable"
              [value]="field.control.value | phone">
          }
        }
        <!-- Slide toggle fields -->
        @if (field.type === 'slide' && field.editable) {
          <mat-slide-toggle [formControlName]="field.name">{{field.control.value ? 'Active' :
          'Inactive'}}</mat-slide-toggle>
          <input matInput hidden disabled>
        }
        <!-- Non-editable fields -->
        @if (!field.editable) {
          <span matTextPrefix>{{ field.prefix }}&nbsp;</span>
          <input matInput [readonly]="true" [value]="field.control.value" class="form-input">
        }
        <!-- Dropdown/select fields -->
        @if (field.type === 'select') {
          <!-- Editable select -->
          @if (field.editable) {
            <mat-select [formControlName]="field.name"
              [value]="field.control.value"
              [placeholder]="field.placeholder ?? ''">
              @for (opt of field.options; track opt) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          }
        }
        <!-- Error messages -->
        @if (field.control.errors?.['required']) {
          <mat-error>{{ field.title }} is required</mat-error>
        }
        @if (field.control.errors?.['whitespace']) {
          <mat-error>{{ field.title }} can't be empty or just white
          space</mat-error>
        }
        @if (field.control.errors?.['pattern']) {
          <mat-error>{{ field.title }} is invalid</mat-error>
        }
        @if (field.control.errors?.['email']) {
          <mat-error>Invalid email</mat-error>
        }
        @if (field.control.errors?.['maxlength'] || field.control.errors?.['minlength']) {
          <mat-error>{{ field.title }}
          has an invalid length</mat-error>
        }
        @if (field.control.errors?.['noPasswordMatch']) {
          <mat-error>Passwords do not match</mat-error>
        }
        @if (field.control.errors?.['max']) {
          <mat-error>Amount can't exceed credit</mat-error>
        }
        @for (error of field.errorMsgs | keyvalue; track error.key) {
          @if (field.control.errors?.[error.key]) {
            <mat-error>{{ error.value }}</mat-error>
          }
        }
      </mat-form-field>
    }
    @if (!(field.editable && field.options && field.options.length > 0)) {
      <p>{{ field.noOptionsMsg }}</p>
    }

    <!-- Multifile fields -->
    @if (field.type === 'multifile') {
      <div>
        <label class="multifile-label" [for]="field.name"><mat-icon>upload</mat-icon> {{ field.title }}</label>
        <div class="multifile-files">
          @if (files.get(field.name)) {
            {{ files.get(field.name)!.name }}
            <button mat-button (click)="removeFile(fileInput, field.name)">
              <mat-icon >delete</mat-icon>
            </button>
          }
        </div>
        <input class="multifile-input" [id]="field.name" type="file" (change)="onFileChange(fileInput, field.name)"
          #fileInput>
          @for (error of field.errorMsgs | keyvalue; track error.key) {
            @if (field.control.errors?.[error.key]) {
              <mat-error>{{ error.value }}</mat-error>
            }
          }
        </div>
      }
    }
  </mat-form>
